import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08dda507"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { useStore } from "vuex";
import { GetterTypes, MutationTypes } from "@/store";
import { useComputedValue } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'FullSizeImage',
  setup(__props) {

const { commit } = useStore();
const src = useComputedValue<string | undefined>(
  GetterTypes.GET_FULL_SIZE_IMAGE,
);

const closeWindow = (e: MouseEvent) => {
  commit(MutationTypes.SET_FULL_SIZE_IMAGE, null);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "screen-cover",
    onClick: _withModifiers(closeWindow, ["stop"])
  }, [
    _createElementVNode("img", {
      class: "image",
      src: _unref(src),
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, null, 8, _hoisted_1)
  ]))
}
}

})